import React, { useState } from "react";

import { FIELD_TYPE, FORMAT_TIME, tabKeys, TT_PHIEU_VTYT } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { ColumnsEdit } from "../../../../../../types/models/column-table-edit";
import { Button, Popconfirm, Row, Select } from "antd";
import Icons from "../../../../../../assets/icons";
import { EyeOutlined } from "@ant-design/icons";
import {
  startOfMonth,
  endOfMonth,
  eachWeekOfInterval,
  format,
  startOfWeek,
  addWeeks,
  addDays,
} from "date-fns";
import { setLoading } from "redux/reducer/medicineStore";
import dayjs from 'dayjs';

const { INPUT, DATE, COMBO_BOX,DATE_DISABLE_NO_DAY, AUTO_COMPLETE, CODE, NUMBER, SELECT } =
  FIELD_TYPE;

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    width: 50,
    align: "center",
    isResizable: true,
  },
  {
    title: "Ngày tháng năm",
    key: "ngayThangNam",
    show: true,
    dataIndex: "ngayThangNam",
    width: 120,
    align: "center",
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
    isResizable: true,
  },
  {
    title: "Số đến",
    key: "soDen",
    show: true,
    dataIndex: "soDen",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Nơi gửi",
    key: "noiGui",
    show: true,
    dataIndex: "noiGui",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Số ký hiệu",
    key: "soKyHieu",
    show: true,
    dataIndex: "soKyHieu",
    align: "left",
    isResizable: true,
    width: 120,
  },
  {
    title: "Ngày tháng văn bản",
    key: "ngayThangNamVanBan",
    show: true,
    dataIndex: "ngayThangNamVanBan",
    width: 120,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Tên loại và trích yếu nội dung",
    key: "tenLoaiVaTrichYeu",
    show: true,
    dataIndex: "tenLoaiVaTrichYeu",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Đơn vị hoặc người nhận",
    key: "noiNhan",
    show: true,
    dataIndex: "noiNhan",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Ký nhận",
    key: "kiNhan",
    show: true,
    dataIndex: "kiNhan",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    dataIndex: "ghiChu",
    width: 120,
    align: "left",
    isResizable: true,
  },
  {
    title: "Tác vụ",
    dataIndex: "action",
    key: "action",
    show: true,
    align: "center",
    width: 80,
},
];

const itemsInputField: DataFormField[] = [
  {
    type: DATE_DISABLE_NO_DAY,
    name: "tuNgay",
    label: "Ngày tháng văn bản từ",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 6, xl: 6 },
    wrapperCol: { xs: 14, md: 16, lg: 18, xl: 18 },
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "denNgay",
    label: "Ngày tháng văn bản đến",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 6, xl: 6 },
    wrapperCol: { xs: 14, md: 16, lg: 18, xl: 18 },
    disableDate: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: INPUT,
    name: "soDen",
    label: "Số đến",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 6, xl: 6 },
    wrapperCol: { xs: 14, md: 16, lg: 18, xl: 18 },
  },
  {
    type: INPUT,
    name: "soKyHieu",
    label: "Số ký hiệu",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 6, xl: 6 },
    wrapperCol: { xs: 14, md: 16, lg: 18, xl: 18 },
  },
  {
    type: INPUT,
    name: "noiNhan",
    label: "Người nhận",
    disable: false,
    css: {
      xl: 12,
      lg: 12,
      md: 12,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 6, xl: 6 },
    wrapperCol: { xs: 14, md: 16, lg: 18, xl: 18 },
  },
  // {
  //   type: INPUT,
  //   label: "Tên file",
  //   name: "tenFile",
  //   disable: false,
  //   css: {
  //     xl: 12,
  //     lg: 12,
  //     md: 12,
  //     sm: 24,
  //     xs: 24,
  //   },
  //   labelCol: {xs: 10, md: 8, lg: 6, xl: 6},
  //   wrapperCol: {xs: 14, md: 16, lg: 18, xl: 18},
  // },
];

export { allColumns, itemsInputField};
